export const PAGE_SIZE_OPTIONS = [10, 20, 50];
export const DEFAULT_PAGE_SIZE = 20;

/** Worth a pager: more rows than the smallest page, so the size picker can still shrink a long page. */
export function needsPager(total: number): boolean {
  return total > PAGE_SIZE_OPTIONS[0];
}

export function Pagination({
  total,
  limit,
  offset,
  onLimitChange,
  onOffsetChange,
}: {
  total: number;
  limit: number;
  offset: number;
  onLimitChange: (limit: number) => void;
  onOffsetChange: (offset: number) => void;
}) {
  const from = total === 0 ? 0 : offset + 1;
  const to = Math.min(total, offset + limit);
  const atStart = offset <= 0;
  const atEnd = offset + limit >= total;

  return (
    <div className="pagination" role="navigation" aria-label="Pages">
      <span className="pagination__summary">
        {from}–{to} of {total.toLocaleString("en-US")}
      </span>
      <div className="row" style={{ gap: "0.4rem" }}>
        <label className="pagination__size">
          Show
          <select
            value={limit}
            onChange={(e) => {
              onLimitChange(Number(e.target.value));
              onOffsetChange(0);
            }}
          >
            {PAGE_SIZE_OPTIONS.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
          per page
        </label>
        <button
          type="button"
          className="btn btn--sm btn--ghost"
          disabled={atStart}
          onClick={() => onOffsetChange(Math.max(0, offset - limit))}
        >
          ← Prev
        </button>
        <button
          type="button"
          className="btn btn--sm btn--ghost"
          disabled={atEnd}
          onClick={() => onOffsetChange(offset + limit)}
        >
          Next →
        </button>
      </div>
    </div>
  );
}
